<template>
    <jet-dialog-modal :show="true" @close="$emit('close')">
        <template #title>
            You are limited to {{ $page.props.trial_contact_limit }} Contacts on a Trial Account
        </template>

        <template #content>
            <div>
                While on your TextSpot trial, you can only only test functionality by sending messages to up to {{ $page.props.trial_contact_limit }} contacts.
            </div>
            <div class="mb-2 mt-2">
                We know this is frustrating, but carriers require this to protect against spam. <br /><br />
            
                Once you upgrade we'll get you registered with carriers so you can send messages to more contacts. <br /><br />
            </div>
        </template>

        <template #footer>
            <a href='#' class="whitespace-nowrap mr-2 px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900" 
                v-on:click="$emit('close')" 
            >
                Okay, Got It
            </a>
    
            <Link :href="route('subscriptions.index')" @click="$emit('close')" class="">
                <jet-button secondary class="">
                    VIEW PLANS & UPGRADE
                </jet-button>
            </Link>

        </template>
    </jet-dialog-modal>

</template>


<script>

export default {
    name: 'LimitedContactsOnTrialModal',
    emits: ['close'],
    components: {
    },
    computed: {
    }

}
</script>